import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=64fd10a8&"
import script from "./Header.controller.js?vue&type=script&lang=js&"
export * from "./Header.controller.js?vue&type=script&lang=js&"
import style0 from "./Header.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports